module.exports = __webpack_public_path__ + "images/circle.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/gmap/img/circle.png
// module id = ./app/components/gmap/img/circle.png
// module chunks = app